import{jsxs as c,jsx as t,Fragment as z}from"react/jsx-runtime";import{useState as I}from"react";import o,{css as $}from"styled-components";import{Label as R}from"../FieldLabel.js";import{BodyTextStyle as V,CaptionStyle as q}from"../../typography/BodyText/index.js";import{useNameAndId as C}from"../../hooks/useNameAndId.js";import"../../shared/media-queries.js";import"../../shared/helpers.js";const D=$`
  border: 1px solid ${({theme:e})=>e.colors.grayscaleToned.light2};
  color: ${({theme:e})=>e.colors.text.disabled};
  fill: ${({theme:e})=>e.colors.text.disabled};
`,G=$`
  border: 2px solid ${({theme:e})=>e.colors.error.dark};
`,H=$`
  border: 2px solid ${({theme:e})=>e.colors.grayscaleToned.dark5};
  color: ${({theme:e})=>e.colors.text.dark};
  fill: ${({theme:e})=>e.colors.text.dark};
`,L=o.div`
  position: relative;
  padding: 0;
  display: block;
`,M=o.div`
  display: flex;
  text-align: center;
  align-items: center;
  box-sizing: border-box;
  height: 3rem;

  background-color: ${({theme:e})=>e.colors.background.light};

  border: 1px solid ${({theme:e})=>e.colors.grayscaleToned.dark5};
  transition: all 150ms;

  padding: 0.75rem 0.6rem;

  ${({hasError:e,isFocused:a})=>!e&&a&&H}
  ${({disabled:e})=>e&&D}
  ${({hasError:e})=>e&&G}
  ${({centered:e})=>e&&"text-align: center;"}
`,O=o.input`
  ${V}
  width: 100%;
  cursor: text;
  outline: none;
  border: none;
  background-color: transparent;

  :disabled {
    color: ${({theme:e})=>e.colors.text.disabled};
    fill: ${({theme:e})=>e.colors.text.disabled};
  }
`,P=o.span`
  display: flex;
  font-family: ${({theme:e})=>e.typography.fontBaseFamily};
  font-size: 1.25rem;
  line-height: 1.5rem;

  svg {
    width: 1.375rem;
    height: 1.375rem;
  }
`,_=o.div`
  ${q}
  margin-top: 0.25rem;

  ${({centered:e})=>e&&"width: 100%; text-align: center;"}
`,J=o.span`
  display: block;
  color: ${({theme:e})=>e.colors.text.disabled};
`,K=o.span`
  display: block;
  color: ${({theme:e})=>e.colors.error.dark};
`,g=({placeholder:e="",isDisabled:a=!1,centered:m=!1,hasError:h=!1,className:y,helperText:s,label:d="",onBlur:k=()=>null,onFocus:v=()=>null,forwardRef:F,suffix:f,name:B,errors:i,isAutoFocused:T=!1,...u})=>{const[p,x]=I(!1),w=!!u.value,b=i&&Array.isArray(i)&&i?.length>0,{name:E,id:r}=C("text-input",B),j=i?.map((l,n)=>`${r}-error-${n}`)??[],A=[s?`${r}-helper`:null,...j].filter(Boolean).join(" "),N=l=>{x(!0),v(l)},S=l=>{x(!1),k(l)};return c(L,{className:y,children:[c(M,{isFocused:p,disabled:a,centered:m,hasError:h,hasPlaceholder:!!e,children:[t(O,{...u,id:r,name:E,"aria-labelledby":d?`${r}-label`:void 0,"aria-describedby":A||void 0,"aria-invalid":b||h,ref:F,onFocus:N,onBlur:S,disabled:a,placeholder:d&&!p?"":e,autoFocus:T}),f&&t(P,{children:f})]}),d&&t(R,{id:`${r}-label`,htmlFor:r,isFocused:p,centered:m,hasError:h,hasValue:w,disabled:a,children:c(z,{children:[d,t("span",{})]})}),(s||b)&&c(_,{centered:m,children:[s&&t(J,{id:`${r}-helper`,children:s}),b&&i.map((l,n)=>t(K,{id:`${r}-error-${n}`,role:"alert","aria-live":"assertive",children:l},`${r}-error-${n}`))]})]})};export{g as TextField,g as default};
